import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section, SectionHeading, Reveal } from '../shared/Section';
const forYou = ['Querés aliviar el dolor sin depender de pastillas ni terapias caras', 'Pasás muchas horas sentado/a y lo pagás con rigidez y molestias', 'Querés empezar desde cero, sin experiencia previa en ejercicio', 'Buscás rutinas cortas que puedas hacer en casa en pocos minutos', 'Ya hacés ejercicio pero el dolor y la rigidez no desaparecen', 'Querés un cambio real y sostenible, no un alivio temporal'];
const notForYou = ['Buscás resultados mágicos sin ningún tipo de práctica', 'Esperás eliminar el dolor crónico severo en 24 horas', 'No estás dispuesto/a a dedicar 15 minutos por día', 'Solo querés información sin aplicarla en tu vida real', 'Tenés una lesión grave que requiere atención médica urgente', 'Preferís métodos extremos o rehabilitación clínica especializada'];
export function ForYou() {
  return <Section id="es-para-mi" data-id="element-84" data-mp="3p9ka2g67lia9">
      <Reveal data-id="element-85" data-mp="3p8se348p9ijg">
        <SectionHeading title="¿Es para mí?" data-id="element-86" data-mp="3pabtytqg1rkp" />
      </Reveal>

      <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-87" data-mp="3l88hq2vyaiyd">
        <Reveal data-id="element-88" data-mp="3l9rxzthlwu05">
          <div className="h-full rounded-2xl border border-forest-100 bg-forest-50 p-7" data-id="element-89" data-mp="3labfxa79bie6">
            <h3 className="flex items-center gap-2 font-display text-xl font-semibold text-forest-800" data-id="element-90" data-mp="30982azmsk0j">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-forest-500 text-white" data-id="element-91" data-mp="3uaq0g7cectgm">
                <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-92" data-mp="81f6mpfz31hz" />
              </span>
              Es para vos si…
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-93" data-mp="lrsaafltzu1i">
              {forYou.map(t => <li key={t} className="flex items-start gap-3 text-sm leading-relaxed text-forest-700/85" data-id="element-94" data-mp="gt8oqgb5gk9o">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-500" strokeWidth={3} data-id="element-95" data-mp="vq844qc8thep" />
                  {t}
                </li>)}
            </ul>
          </div>
        </Reveal>

        <Reveal index={1} data-id="element-96" data-mp="xvwctmhk9ee0">
          <div className="h-full rounded-2xl border border-sand-200 bg-white p-7" data-id="element-97" data-mp="xwphmhwyltti">
            <h3 className="flex items-center gap-2 font-display text-xl font-semibold text-forest-800/70" data-id="element-98" data-mp="12uzgb2hw7cjv">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-forest-700/10 text-forest-700/60" data-id="element-99" data-mp="17rpwdptp685a">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-100" data-mp="1clu5aemiwq90" />
              </span>
              No es para vos si…
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-101" data-mp="1lk61cw65sg8u">
              {notForYou.map(t => <li key={t} className="flex items-start gap-3 text-sm leading-relaxed text-forest-700/60" data-id="element-102" data-mp="1qk1v82l56rao">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-700/40" strokeWidth={3} data-id="element-103" data-mp="1vjetrkldlmt3" />
                  {t}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </Section>;
}